import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAuthStore = create()(persist((set) => ({
    accessToken: null,
    refreshToken: null,
    user: null,
    isAuthenticated: false,
    setAuth: (tokens, user) => set({
        accessToken: tokens.accessToken,
        refreshToken: tokens.refreshToken ?? null,
        user,
        isAuthenticated: true,
    }),
    clearAuth: () => set({
        accessToken: null,
        refreshToken: null,
        user: null,
        isAuthenticated: false,
    }),
}), {
    name: 'auth-storage',
    // Only persist token and user — isAuthenticated is derived on rehydration
    partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
    }),
}));
